import {HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {catchError, Observable, switchMap, throwError} from "rxjs";
import {IdentityService} from "../api/services/identity.service";
import {inject} from "@angular/core";
import {AuthStateService} from "../services/auth-state.service";

export const authInterceptor: HttpInterceptorFn = (req, next) => {

  if (req.url.includes('cms.smzh.ch')) {
    return next(req);
  }

  const identityService = inject(IdentityService);
  const authStateService = inject(AuthStateService);

  const accessToken = localStorage.getItem('accessToken');
  const refreshToken = localStorage.getItem('refreshToken');

  // The passkey login ceremony is anonymous: a leftover token must not be
  // attached, and a 401 from it must not trigger the refresh/logout path.
  if (req.url.includes('/api/Identity/login') ||
    req.url.includes('/api/Identity/register') ||
    req.url.includes('/api/Identity/refresh') ||
    req.url.includes('/api/Identity/passkeys/login/')) {
    return next(req);
  }

  if (accessToken) {
    req = addTokenToRequest(req, accessToken);
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && refreshToken) {
        return handleUnauthorizedError(req, next, identityService, refreshToken, authStateService);
      }

      return throwError(() => error);
    })
  );
};

function addTokenToRequest(req: any, token: string) {
  return req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`
    }
  });
}

function handleUnauthorizedError(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
  identityService: IdentityService,
  refreshToken: string,
  authService: AuthStateService
): Observable<HttpEvent<unknown>> {
  return identityService.apiIdentityRefreshPost({
    body: {
      refreshToken: refreshToken
    }
  }).pipe(
    switchMap(response => {
      localStorage.setItem('accessToken', response.accessToken!);
      localStorage.setItem('refreshToken', response.refreshToken!);

      const newRequest = addTokenToRequest(req, response.accessToken!);
      return next(newRequest);
    }),
    catchError(refreshError => {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');

      authService.clearUser();
      void authService.dismissOpenModals();
      authService.navigateToLogin();

      return throwError(() => refreshError);
    })
  );
}
